import React from 'react';
import './LoadingSpinner.css';

export default function LoadingSpinner({ label = 'Ачаалж байна...', inline = false, className = '' }) {
  return (
    <span className={`loading-indicator ${inline ? 'loading-indicator-inline' : ''} ${className}`} role="status">
      <span className="loading-indicator-ring" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}

export function LoadingBoundary({ isLoading, children, fallback, ...props }) {
  return isLoading ? (fallback ?? <LoadingSpinner {...props} />) : children;
}
